import { createFileRoute } from "@tanstack/react-router";
import { BnServiceDetail, bnServiceHead, type BnServiceContent } from "@/components/bn/BnServiceDetail";

const C: BnServiceContent = {
  path: "/bn/services/seo",
  crumb: "এসইও",
  title: "এসইও সার্ভিস বাংলাদেশ — টেকনিক্যাল, লোকাল ও কনটেন্ট এসইও",
  desc: "টেকনিক্যাল অডিট, লোকাল এসইও, কীওয়ার্ড ও কনটেন্ট কৌশল এবং লিংক অর্জন — গুগলে বাস্তব ট্রাফিক ও লিড আনার জন্য বাংলাদেশি ব্যবসার এসইও সার্ভিস।",
  keywords: ["seo service bangladesh", "এসইও সার্ভিস", "seo bangla", "লোকাল এসইও"],
  eyebrow: "সার্চ ইঞ্জিন অপটিমাইজেশন",
  h1: <>গুগলে র‍্যাংক করুন, <span className="text-gradient">লিড পান।</span></>,
  subtitle: "এসইও হলো আপনার সাইটকে গুগলের কাছে বোধগম্য ও বিশ্বাসযোগ্য করে তোলা — যাতে যারা আপনার সেবা খুঁজছে, তারা আপনাকেই খুঁজে পায়।",
  takeaways: [
    "টেকনিক্যাল ভিত্তি (ক্রল, ইনডেক্স, গতি) ঠিক না হলে কনটেন্ট বা লিংক কোনোটাই পুরো কাজ করে না।",
    "প্রতিটি গুরুত্বপূর্ণ কীওয়ার্ডের জন্য একটি নির্দিষ্ট পেজ — এটাই ভালো কনটেন্ট কৌশলের মূল।",
    "রিপোর্ট হয় Search Console ও GA4-এর বাস্তব ডেটা থেকে, কোনো র‍্যাংকিং গ্যারান্টি ছাড়া।",
  ],
  programTitle: "এসইও প্রোগ্রাম",
  programDesc: "অডিট দিয়ে শুরু, তারপর মাসিক স্প্রিন্টে ঠিক করা, প্রকাশ করা ও লিংক অর্জন — প্রতিটি কাজের মালিকানা লিখিত।",
  price: "অডিট ২০,০০০–৫০,০০০ টাকা · লোকাল এসইও মাসে ১৫,০০০–৩৫,০০০ টাকা",
  cta: "এসইও নিয়ে কথা বলুন",
  deliverables: [
    "টেকনিক্যাল এসইও অডিট (ক্রল, ইনডেক্স, Core Web Vitals)",
    "কীওয়ার্ড-টু-পেজ ম্যাপ ও প্রতিযোগী বিশ্লেষণ",
    "অন-পেজ অপটিমাইজেশন ও ইন্টারনাল লিংকিং",
    "Google Business Profile ও লোকাল সিগন্যাল",
    "বাংলা ও ইংরেজি কনটেন্ট ব্রিফ",
    "মাসিক রিপোর্ট (Search Console ও GA4)",
  ],
  outcomes: ["বেশি অর্গানিক ট্রাফিক", "গুগল ম্যাপে উপস্থিতি", "সার্চ থেকে নিয়মিত লিড"],
  faqs: [
    { q: "এসইও-তে ফল পেতে কতদিন লাগে?", a: "সাধারণত টেকনিক্যাল ঠিক করার প্রভাব ৪–৮ সপ্তাহে দেখা যায়, আর প্রতিযোগিতামূলক কীওয়ার্ডে স্থায়ী উন্নতি আসতে ৪–৬ মাস লাগে।" },
    { q: "আপনি কি প্রথম পেজে র‍্যাংকিংয়ের গ্যারান্টি দেন?", a: "না। কেউ সৎভাবে গুগল র‍্যাংকিংয়ের গ্যারান্টি দিতে পারে না। আমি পরিষ্কার পরিকল্পনা, লিখিত কাজ ও বাস্তব ডেটার রিপোর্ট দিই।" },
    { q: "লোকাল এসইও কি আমার ব্যবসার জন্য দরকার?", a: "যদি আপনার গ্রাহক নির্দিষ্ট শহর বা এলাকা থেকে আসে, তাহলে হ্যাঁ। Google Business Profile ও এলাকাভিত্তিক পেজ ছোট ব্যবসার জন্য সবচেয়ে দ্রুত ফল দেয়।" },
    { q: "এসইও-র খরচ কত?", a: "একবারের অডিট ২০,০০০–৫০,০০০ টাকা, মাসিক লোকাল এসইও ১৫,০০০–৩৫,০০০ টাকা। বিস্তারিত প্যাকেজ ও দাম পেজে দেখুন।" },
  ],
  serviceName: "এসইও সার্ভিস",
  serviceType: "Search Engine Optimization",
  related: [
    { to: "/bn/services/aeo", label: "AEO প্রোগ্রাম" },
    { to: "/bn/services/geo", label: "GEO প্রোগ্রাম" },
  ],
};

export const Route = createFileRoute("/bn/services/seo")({
  head: () => bnServiceHead(C),
  component: () => <BnServiceDetail c={C} />,
});
